import { render, staticRenderFns } from "./CnesPlugin.vue?vue&type=template&id=5ef76708&scoped=true"
import script from "./CnesPlugin.vue?vue&type=script&lang=ts"
export * from "./CnesPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CnesPlugin.vue?vue&type=style&index=0&id=5ef76708&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5ef76708",
  null
  ,true
)

export default component.exports